// utils/excelUtils.js
// Download filtered resumes as zip
export const downloadFilteredResumes = async (currentFilters = {}, type, showSuccess, showError) => {
  try {
    const queryParams = new URLSearchParams();

    const filterKeys = [
      "departments",
      "skillsKnown",
      "branches",
      "companyLocations",
      "experiences",
      "resumeStatus",
      "courses",
      "courseTypes",
      "courseNames",
      "courseType",
      "courseName",
      "batch",
      "learningMode",
      "branch",
      "searchField",
      "searchValue",
      "fromPassedYear",
      "toPassedYear"
    ];

    // Add only existing filters to URL
    filterKeys.forEach((key) => {
      if (currentFilters[key]) {
        queryParams.append(key, currentFilters[key]);
      }
    });
    queryParams.append("type", type);
    const token = localStorage.getItem("token");
    const url = `${process.env.REACT_APP_API_URL}/resumes/downloadall?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    const currentDate = new Date().toISOString().split("T")[0];
    link.download = `Filtered_Resumes_${currentDate}.zip`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);

    showSuccess("Resumes downloaded successfully!");
  } catch (error) {
    console.error("Error downloading resumes:", error);
    showError("Failed to download resumes. Please try again.");
  }
};


export const formatValue = (value) => {
  if (value === null || value === undefined || value === 'null' || value === '') {
    return '';
  }
  return value;
};

const getExcelEndpoint = (type) => {
  switch (type) {
    case "getAll":
      return "/all-students-excel";
    case "mentor":
      return "/mentor-students-excel";
    case "placementEligible":
    default:
      return "/placement-eligible-students-excel";
  }
};
// Add this function to utils/excelUtilspb.js
export const downloadFilteredExcel = async (filters, type, showSuccess, showError) => {
  try {
    const token = localStorage.getItem('token');

    // Build query string from filters
    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });

    const endpoint = getExcelEndpoint(type);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${endpoint}?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to download Excel file');
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const currentDate = new Date().toISOString().split('T')[0];
    link.download = `Student_Details_${currentDate}.xlsx`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    showSuccess('Excel file downloaded successfully!');
  } catch (error) {
    console.error('Error downloading Excel:', error);
    showError(`Failed to download Excel: ${error.message}`);
  }
};